import NCM from './ncm'
import CEST from './cest'
import ICMS from './icms'
import NESH from './nesh'
import PISCOFINS from './piscofins'
import IPI from './ipi'
import Natureza from './natureza'

export default class ItemVO {
  constructor(id, codigo, descricao) {
    this.id = id
    this.codigo = codigo
    this.descricao = descricao
    this.ncm = new NCM()
    this.cest = new CEST()
    this.icms = new ICMS()
    this.nesh = new NESH()
    this.pisCofins = new PISCOFINS()
    this.ipi = new IPI()
    this.natureza = new Natureza()
  }
}
